import mixpanel from 'mixpanel-browser';

export const isAnalyticsEnabled = () => Boolean(process.env.MIXPANEL_TOKEN);

export const initializeAnalytics = () => {
  if (!isAnalyticsEnabled()) {
    return false;
  }

  mixpanel.init(process.env.MIXPANEL_TOKEN);
  return true;
};

export const trackEvent = (event, options) => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.track(event, options);
};

export const createAlias = uid => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.alias(uid);
};

export const identifyUser = uid => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.identify(uid);
};

export const setPeople = (...params) => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.people.set(...params);
};

export const registerSuperProperties = (...params) => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.register(...params);
};

export const resetAnalytics = () => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.reset();
};

export const unregisterSuperProperty = propertyName => {
  if (!isAnalyticsEnabled()) {
    return null;
  }

  return mixpanel.unregister(propertyName);
};
